import {useEffect, useRef} from 'react';
import {useInvisibleFrame} from '@stripe-internal/stripethirdparty';
import {ClientProvider} from '@stripe-internal/conversations-ui';
import {
  ClientUrls,
  ObservabilityConfig,
} from '@stripe-internal/conversations-client';
import {TwilioClient} from './client';
import {STPTwilio} from './stp';

const getBaseURL = () => {
  const {hostname} = window.location;
  if (hostname.includes('localhost')) {
    return 'http://localhost:8080';
  } else {
    const webpackHostname = hostname.replace(
      'stripethirdparty',
      'stripethirdparty_webpack',
    );
    return `https://${webpackHostname}`;
  }
};

export const TwilioClientProvider = ({
  baseURL = getBaseURL(),
  value,
  urls,
  observability,
  children,
}: {
  baseURL?: string;
  urls?: Partial<ClientUrls>;
  observability?: ObservabilityConfig;
  value?: TwilioClient;
  children: React.ReactNode;
}) => {
  const ref = useRef<TwilioClient>(
    value || new TwilioClient({urls, observability}),
  );
  const client = ref.current;

  const invisibleFrame = useInvisibleFrame({
    baseURL,
    type: 'Twilio',
    handleMessage: client.handleStpMessage,
  });

  useEffect(() => {
    if (invisibleFrame?.sendRequest) {
      client.init(new STPTwilio(invisibleFrame.sendRequest));
    }
  }, [client, invisibleFrame]);

  return <ClientProvider value={client}>{children}</ClientProvider>;
};
